import { forwardRef } from "react";
import { Form, Settings, SettingsItem, TextField } from "ui";
import BamboraModel from "./types/BamboraModel";
import FormRef from "../types/FormRef";

type BamboraFormProps = {
    errors: any;
    loading: boolean;
    onSubmit: (data: BamboraModel) => void;
};

const BamboraForm = forwardRef<FormRef, BamboraFormProps>(
    ({ errors, loading, onSubmit }, ref) => {
        return (
            <Form
                ref={ref}
                data={{}}
                errors={errors}
                fields={{
                    api_key: { default: "" },
                }}
                loading={loading}
                onSubmit={onSubmit}
                preventLeftForm
                unsaved={false}
            >
                {(context: any) => {
                    return (
                        <>
                            <Settings>
                                <SettingsItem label="API Key">
                                    <TextField
                                        fullWidth
                                        id="api_key"
                                        margin="none"
                                    />
                                </SettingsItem>
                            </Settings>
                        </>
                    );
                }}
            </Form>
        );
    },
);

export default BamboraForm;
